import './styles/index.scss';

import React from 'react';
import { ConnectedRouter } from 'connected-react-router'
import {
  Route,
  Switch,
} from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import Home from 'pages/home';
import CollectVibe from 'pages/collectVibe';

import './firebase';

import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import createStore from 'store';
import { history } from 'utils/history';

const { store, persistor } = createStore(history);

export default function App() {
  return (
    <HelmetProvider>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ConnectedRouter history={history}>
            <Switch>
              <Route exact path="/">
                <Home />
              </Route>
              <Route path="/collect/:id">
                <CollectVibe />
              </Route>
              <Route path="/terms" render={() => { 
                window.location.href = 'https://sociaaal.notion.site/Vibe-Terms-of-Use-6c01052e40f442428a6e5f2db3a75fff'; 
                return null;
              }} />
              <Route path="/privacy" render={() => { 
                window.location.href = 'https://sociaaal.notion.site/Sociaaal-Privacy-Policy-8a0c608025c341968d60e75d9a46a292'; 
                return null;
              }} />
            </Switch>
          </ConnectedRouter>
        </PersistGate>
      </Provider>
    </HelmetProvider>
  );
}